<template>
  <div class="row m-0">
    <div class="col-12 p-0 border-bottom">
      <div class="row m-0 h-100">
        <div class="d-none d-sm-block col-sm-2 col-xl-2 p-0">
          <img :src="cartItem.thumbnail_url" alt="..." class="img-fluid"/>
        </div>
        <div class="col-12 col-sm-10 p-3 h-100">
          <div class="row m-0 align-items-start h-100">
            <div class="col-12 col-md-6 px-0 pr-md-2 mb-3 mb-md-0">
              <h4 class="nomargin">{{ cartItem.title }}</h4>
              <!-- <p class="card-text truncate" v-if="!isCheckout">{{ cartItem.description }}</p> -->
            </div>
            <div class="col-8 col-sm-6 col-md-4 p-0 mb-2 mb-md-0">
              <div class="row m-0 align-items-center">
                <div class="col p-0">
                  <span v-if="isCheckout">{{cartItem.quantity}}</span>
                  <input type="number" class="form-control text-center"
                    :value="cartItem.quantity"
                    @input="updateQuantity"
                    min="0"
                    v-else
                  >
                </div>
                <div class="col-auto text-right mt-2 small_text px-1" v-if="!isCheckout">
                  @ (R {{ cartItem.price }} each)
                </div>
              </div>
            </div>
            <div class="col-12 col-md-2 p-0 text-right h-md-100">
              <div class="row m-0 h-100 align-items-center">
                <div class="col-9 col-md-12 p-0">
                  <h4 class="mb-0">R {{ subtotal }}</h4>
                </div>
                <div class="col-3 col-md-12 p-0 align-self-end small_font order-first order-md-last" @click="removeItem">
                  <div class="row m-0 align-items-center justify-content-md-end">
                    <div class="col-auto pl-0 pr-1"><ios-trash-icon /></div>
                    <div class="col-auto p-0">Remove</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <tr>
    <td data-th="Product">
      <div class="row">
        <div class="col-sm-2 d-none d-sm-block">
          <img :src="cartItem.thumbnail_url" alt="..." class="img-fluid"/>
        </div>
        <div class="col-sm-10">
          <h4 class="nomargin">{{ cartItem.title }}</h4>
          <p>{{ cartItem.description }}</p>
        </div>
      </div>
    </td>
    <td data-th="Price">{{ cartItem.price }}</td>
    <td data-th="Quantity">
      <input type="number" class="form-control text-center"
        :value="cartItem.quantity"
        @input="updateQuantity"
        min="0">
    </td>
    <td data-th="Subtotal" class="text-center">R {{ subtotal }}</td>
    <td class="actions text-right" data-th="">
      <span @click="removeItem"><ios-trash-icon /></span>
    </td>
  </tr> -->
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: ['cartItem', 'isCheckout'],
  computed: {
    subtotal () {
      return this.cartItem.quantity * this.cartItem.price
    }
  },
  methods: {
    ...mapActions(['updateCart', 'removeItemInCart']),
    removeItem () {
      let vm = this
      this.removeItemInCart({
        item: vm.cartItem
      })
    },
    updateQuantity (event) {
      console.log('updateing')
      console.log(this.cartItem)
      this.updateCart({
        item: this.cartItem,
        quantity: parseInt(event.target.value),
        isAdd: false
      })
    }
  }
}
</script>
<style scoped>
  .truncate {
    word-wrap: break-word;
    overflow-y: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    height: 3;
  }
  .small_font {
    font-size: 0.6rem;
  }
  .small_font .ion {
    font-size: 1rem;
  }
  @media (min-width: 768px) {
    .h-md-100 {
      height: 100% !important;
    }
  }
</style>
